import { useEffect } from 'react'

import IService from '../interfaces/service'

export const useFetchResource = (
  callback: IService['loadById'],
  id: number,
  params?: any,
  dependencies: any[] = [],
) => {
  useEffect(() => {
    const fetchData = async () => {
      await callback(id, params)
    }
    fetchData()
  }, dependencies)
}
